import React from 'react';
import PropTypes from 'prop-types';

import Booking from 'models/booking';
import Review from 'models/review';

import LocationRating from 'components/common/location-rating';
import RatingsCar from 'components/svgs/icons/ratings-car';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  review: PropTypes.instanceOf(Review),
  reviewBooking: PropTypes.func.isRequired,
};

const defaultProps = {
  review: null,
};

const RateLocation = ({ booking, review, reviewBooking }) => {
  if (booking.isMonthly) { return null; }

  if (review) {
    return <LocationRating rating={review.rating} />;
  }


  return (
    <div className="rate-this-location">
      <span className="small-svg"><RatingsCar /></span>
      <span className="grid-header weak">How was it?</span>
      <a className="grid-header link" onClick={() => { reviewBooking({ booking }); }}>Rate this location</a>
    </div>
  );
};

RateLocation.propTypes = propTypes;
RateLocation.defaultProps = defaultProps;
export default RateLocation;
